import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Tooltip,
    Switch,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {FieldTimeOutlined, SearchOutlined, ReloadOutlined, InfoCircleFilled} from '@ant-design/icons'
import moment from 'moment';
import View from './view.js'
import {ReactSVG} from "react-svg";


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
            total: true,
            list2: []
        };
        this.view = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/fangjian', ['首页', '房间管理', '可视化平面图'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
        if (name == 'yq_id') {
            setTimeout(() => {
                that.getBuilding(value, 0)
            })
        }
    }

    getBuilding = (yq_id, type = 0) => {
        let that = this
        let newcondition = Object.assign({}, this.state.newcondition, type == 0 ? {building: null} : {})
        that.setState({
            building_react: [],
            newcondition
        })
        fetch('/Room/getBuilding', {
            // post提交
            method: "POST", body: JSON.stringify({
                yq_id
            })
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    building_react: data.data
                })
                if (type == 1) {
                    that.getdata(1, null)
                }
            })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.map = 1
        fetch('/Room/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    yq_react: data.yq_react ? data.yq_react : [],
                    building: data.building ? data.building : [],
                    list2: data.building_arr ? data.building_arr : [],
                    building_name: data.building_name ? data.building_name : "",
                    tableloading: false, // count: Number(data.count)
                })
            })
    }

    arrSVG = (arr) => {
        let _this = this
        if (arr) {
            return arr.map((item, index) => <>
                <div className={'title'} key={'title_' + index}>{item.name}</div>
                <ReactSVG src={item.url}
                          key={'svg_' + index}
                          style={{width: '100%'}}
                          onClick={(e) => {
                              console.log(e.target.id)
                              // e.target.style.fill = "#217DE2"
                              if (e.target.id) {
                                  // e.target.style.fill = "#217DE2"
                                  _this.state.list.map((item2, index2) => {
                                      if (e.target.id == item2.room_id) {
                                          console.log(item2.id)
                                          _this.setState({
                                              id: item2.id
                                          })
                                          setTimeout(() => {
                                              _this.view.current.mdchange()
                                          })
                                      }
                                  })
                              }
                          }}
                          afterInjection={(svg) => {
                              // console.log(svg.querySelectorAll('.st2'))
                              let arr = svg.querySelectorAll("rect");
                              let arr2 = svg.querySelectorAll("polygon")
                              arr = [...arr, ...arr2];
                              arr = arr.filter((item) => item.id)
                              // console.log(arr)
                              // return
                              arr.forEach((item2, index2) => {
                                  item2.style.fill = "#DFE1E5"
                              })
                              let arr3 = svg.querySelectorAll(".area")
                              arr3.forEach((item2, index2) => {
                                  item2.textContent = "待定"
                                  // if (item2.id) {
                                  //     // console.log('#FF0000')
                                  //     item2.style.fill = "#FF0000"
                                  // }
                              })
                              console.log(arr3)
                              _this.state.list.map((item2, index2) => {
                                  arr.forEach((item3, index3) => {
                                      if (item3.id == item2.room_id) {
                                          switch (item2.status) {
                                              case 1:
                                                  item3.style.fill = "#FF3030"
                                                  break;
                                              case 2:
                                                  item3.style.fill = "#18AE3E"
                                                  break;
                                              case 3:
                                                  item3.style.fill = "#217DE2"
                                                  break;
                                              case 4:
                                                  item3.style.fill = "#F78B37"
                                                  break;
                                              case 5:
                                                  item3.style.fill = "#7552FF"
                                                  break;
                                              default:
                                                  item3.style.fill = "#DFE1E5"
                                                  break
                                          }
                                          // item3.textContent = "㎡"
                                      } else {
                                          // item3.style.fill = "#DFE1E5"
                                      }
                                  })
                                  arr3.forEach((item3, index3) => {
                                      if (item3.id == item2.room_id + '-area') {
                                          let html = `<tspan x="0" dy="0">${item2.area}</tspan>`
                                          if (item2.qyjc) {
                                              html += `<tspan x="${item2.x ? item2.x : 0}" dy="30">${item2.qyjc ? item2.qyjc : ''}</tspan>`
                                          }
                                          if (item2.bz) {
                                              html += `<tspan x="${item2.bzx ? item2.bzx : 0}" dy="30">${item2.bz ? item2.bz : ''}</tspan>`
                                          }
                                          item3.innerHTML = html
                                      } else {
                                          // item3.style.fill = "#DFE1E5"
                                      }
                                  })
                              })
                          }}
                />
            </>)
        }
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    chooseld = (yq_id, building) => {
        console.log(yq_id, building)
        let that = this
        let data = Object.assign({}, this.state.newcondition, {yq_id, building})
        that.setState({
            newcondition: data,
            total: false
        })
        setTimeout(() => {
            that.getBuilding(yq_id, 1)
        })
    }

    render() {
        const {tableloading} = this.state;
        const columns = [
            {
                title: '园区',
                dataIndex: 'yqname',
                // render: (text) => <a>{text}</a>,
                onCell: (record, index) => {
                    return {
                        rowSpan: record.hbnum ? record.hbnum : 0,
                    };
                },
            },
            {
                title: '楼栋',
                dataIndex: 'name',
            },
            {
                title: '层数',
                dataIndex: 'csnum',
            },
            {
                title: '房间数',
                dataIndex: 'fjnum',
            },
            {
                title: '已租房间',
                dataIndex: 'yznum',
            },
            {
                title: '待租房间',
                dataIndex: 'dznum',
            },
            {
                title: '操作',
                dataIndex: 'caozuo',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <a onClick={() => {
                                this.chooseld(record.yq_id, record.id)
                            }}>查看</a>
                        </Space>
                    </>)
                },
            },
        ]
        return (<>
            {this.state.total ?
                <>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.list2}
                        pagination={false}
                        // loading={tableloading}
                        // rowSelection={rowSelection}
                        className='table'
                        // scroll={{x: 2800}}
                        // style={{marginBottom: 20}}
                    />
                </>
                :
                <>
                    <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                        <Space wrap>
                            <Select placeholder="所属园区"
                                    style={{width: 200}}
                                    value={this.state.newcondition.yq_id ? this.state.newcondition.yq_id : null}
                                    onChange={this.onSelChange.bind(this, 'yq_id')} allowClear>
                                {this.arrsel(this.state.yq_react)}
                            </Select>
                            <Select placeholder="楼栋"
                                    style={{width: 200}}
                                    value={this.state.newcondition.building ? this.state.newcondition.building : null}
                                    onChange={this.onSelChange.bind(this, 'building')} allowClear>
                                {this.arrsel(this.state.building_react)}
                            </Select>
                            {/*<Input className="input" placeholder="楼栋"
                                   value={this.state.newcondition.building ? this.state.newcondition.building : null}
                                   onChange={this.onChange.bind(this, 'building')} autoComplete="off"/>*/}
                            <Button type="primary" icon={<SearchOutlined/>}
                                    onClick={this.getdata.bind(this, 1)}>查询</Button>
                            {/*<Button type="primary" icon={<ReloadOutlined/>} className='huise'
                                    onClick={this.reset.bind(this)}>重置</Button>*/}
                        </Space>
                        <Space size={30}>
                            <div className={'pms_item i1'}>待租</div>
                            <div className={'pms_item i2'}>已租</div>
                            <div className={'pms_item i3'}>自用</div>
                            <div className={'pms_item i4'}>已预订</div>
                            <div className={'pms_item i5'}>即将到期</div>
                        </Space>
                    </Row>
                    <div className={'pm_list'}>
                        {this.state.building_name ?
                            <div style={{fontSize: 24, fontWeight: 'bold'}}>{this.state.building_name}</div> : null}
                        {this.arrSVG(this.state.building)}
                    </div>
                </>}
            <View id={this.state.id} refresh={this.getdata.bind(this)} ref={this.view} title={'   '}/>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
